/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import Logo from './logo.svg';
import { StyledHeaderLogoLink } from './headerLogoStyles';
import { onEnterKeyPress } from '../../utils/wcagUtils';
export var EmbersHeaderLogo = function EmbersHeaderLogo(_ref) {
  var handleClickLogo = _ref.handleClickLogo;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(StyledHeaderLogoLink, {
    className: classnames('EmbersHeader-logo', {
      clickable: typeof handleClickLogo === 'function'
    }),
    onClick: handleClickLogo || void 0,
    onKeyUp: function onKeyUp(e) {
      return onEnterKeyPress(e, handleClickLogo);
    },
    tabIndex: handleClickLogo ? 0 : -1,
    "aria-labelledby": "embers-header-logo",
    role: "link"
  }, /*#__PURE__*/React.createElement("img", {
    id: "embers-header-logo",
    src: Logo,
    alt: intl.formatMessage({
      id: 'embers.header.eA.promLogo',
      defaultMessage: 'Promethean home page.'
    }),
    "aria-hidden": true
  }));
};